import { CreateJobFormFields } from './validationSchemas';

export enum CreateJobFormSteps {
    JOB = 'job',
    CUSTOMER = 'customer',
    DELIVERY_TERMS = 'deliveryTerms',
    TEAM = 'team',
    ASSIGN_AGENT = 'assignAgent',
}

export const createJobInitialValues: CreateJobFormFields = {
    job: {
        jobId: '',
    },
    customer: {
        customerId: '',
    },
    assignAgent: {
        assignedAgent: '',
    },
    deliveryTerms: {
        incotermCode: '',
    },
    team: {
        teamId: null,
    },
};

export enum JobsTableKeys {
    JOB_ID = 'JOB_ID',
    MANIFEST_ID = 'MANIFEST_ID',
    DECLARATIONS = 'DECLARATIONS',
    CUSTOMER_NAME = 'CUSTOMER_NAME',
    MRN = 'MRN',
    INCOTERM = 'INCOTERM',
    CREATED_BY = 'CREATED_BY',
    ASSIGNED_TO = 'ASSIGNED_TO',
    JOB_STATUS = 'JOB_STATUS',
    ACTIONS = 'ACTIONS',
    EMAIL_NOTIFICATION = 'EMAIL_NOTIFICATION',
}

export const JobTabKeys = {
    OVERVIEW: 'overview',
    DOCUMENTS: 'documents',
    NOTES: 'notes',
    INVOICES: 'invoices',
    HISTORY: 'history',
} as const;

export type JobTabKey = typeof JobTabKeys[keyof typeof JobTabKeys];
